import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function usePost(id) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchPost() {
      setLoading(true);
      const { response, data } = await API.fetchPost(token, id);

      if (response.ok) {
        setResult(data);
        setLoading(false);
        setError(null);
      } else {
        setError({ status: response.status, ...data });
        setLoading(false);
      }
    }

    fetchPost();
  }, [id, setResult, setLoading, setError]);

  return {
    loading,
    error,
    post: result,
  };
}
